/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddCvSearchContactListEntryRequestDto } from '../models';
// @ts-ignore
import type { ContinueCvSearchRequestDto } from '../models';
// @ts-ignore
import type { ContinueCvSearchResponseDto } from '../models';
// @ts-ignore
import type { CreateCvSearchTagAliasRequestDto } from '../models';
// @ts-ignore
import type { CreateCvSearchTagRequestDto } from '../models';
// @ts-ignore
import type { CvSearchContactListItemDto } from '../models';
// @ts-ignore
import type { CvSearchContactListStatusDto } from '../models';
// @ts-ignore
import type { CvSearchMatchesSortByDto } from '../models';
// @ts-ignore
import type { CvSearchProcessSearchResponseDto } from '../models';
// @ts-ignore
import type { CvSearchProcessSearchSortByDto } from '../models';
// @ts-ignore
import type { CvSearchProcessStatusDto } from '../models';
// @ts-ignore
import type { CvSearchStepNameDto } from '../models';
// @ts-ignore
import type { CvSearchTagAliasDto } from '../models';
// @ts-ignore
import type { CvSearchTagValueDto } from '../models';
// @ts-ignore
import type { CvSearchUnknownTagValuesProblemDto } from '../models';
// @ts-ignore
import type { GetCvSearchContactListResponseDto } from '../models';
// @ts-ignore
import type { GetCvSearchInferredTagsResponseDto } from '../models';
// @ts-ignore
import type { GetCvSearchLanguageLevelsResponseDto } from '../models';
// @ts-ignore
import type { GetCvSearchMatchesResponseDto } from '../models';
// @ts-ignore
import type { GetCvSearchProcessDetailsResponseDto } from '../models';
// @ts-ignore
import type { GetCvSearchResultsResponseDto } from '../models';
// @ts-ignore
import type { GetCvSearchTagsResponseDto } from '../models';
// @ts-ignore
import type { GetProcessDefaultCvSearchResponseDto } from '../models';
// @ts-ignore
import type { MergeCvSearchTagsRequestDto } from '../models';
// @ts-ignore
import type { PreviewCvSearchRequestDto } from '../models';
// @ts-ignore
import type { PreviewCvSearchResponseDto } from '../models';
// @ts-ignore
import type { ProcessDefaultCvSearchProposalDto } from '../models';
// @ts-ignore
import type { RenameCvSearchRequestDto } from '../models';
// @ts-ignore
import type { SearchCvSearchTagsResponseDto } from '../models';
// @ts-ignore
import type { SetCvSearchTagParentRequestDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
// @ts-ignore
import type { StartCvSearchFromProcessRequestDto } from '../models';
// @ts-ignore
import type { StartCvSearchFromProcessResponseDto } from '../models';
// @ts-ignore
import type { StartCvSearchRequestDto } from '../models';
// @ts-ignore
import type { StartCvSearchResponseDto } from '../models';
// @ts-ignore
import type { UpdateCvSearchContactListStatusRequestDto } from '../models';
// @ts-ignore
import type { UpdateCvSearchCriteriaRequestDto } from '../models';
// @ts-ignore
import type { UpdateCvSearchJdKeywordsRequestDto } from '../models';
// @ts-ignore
import type { UpdateCvSearchJdKeywordsResponseDto } from '../models';
// @ts-ignore
import type { UpdateCvSearchLocationCriteriaRequestDto } from '../models';
// @ts-ignore
import type { UpdateCvSearchLocationCriteriaResponseDto } from '../models';
// @ts-ignore
import type { UpdateCvSearchTagExpressionRequestDto } from '../models';
// @ts-ignore
import type { UpdateCvSearchTagExpressionResponseDto } from '../models';
// @ts-ignore
import type { UpdateCvSearchTagRequestDto } from '../models';
/**
 * ProcessesCvSearchRestApi - axios parameter creator
 */
export const ProcessesCvSearchRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a candidate to the CV Search contact list
         * @param {number} cvSearchId 
         * @param {AddCvSearchContactListEntryRequestDto} addCvSearchContactListEntryRequestDto Candidate to add to the CV Search contact list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCvSearchContactListEntry: async (cvSearchId: number, addCvSearchContactListEntryRequestDto: AddCvSearchContactListEntryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('addCvSearchContactListEntry', 'cvSearchId', cvSearchId)
            // verify required parameter 'addCvSearchContactListEntryRequestDto' is not null or undefined
            assertParamExists('addCvSearchContactListEntry', 'addCvSearchContactListEntryRequestDto', addCvSearchContactListEntryRequestDto)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/contact-list`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCvSearchContactListEntryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used when the CV Search step of the process configuration is skipped; the CV Search itself stays on the list.
         * @summary Leave a recruitment process without a default CV Search
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearProcessDefaultCvSearch: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('clearProcessDefaultCvSearch', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/cv-search/default`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Continue a paused CV Search process
         * @param {number} cvSearchId 
         * @param {ContinueCvSearchRequestDto} [continueCvSearchRequestDto] Continue CV Search process details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueCvSearch: async (cvSearchId: number, continueCvSearchRequestDto?: ContinueCvSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('continueCvSearch', 'cvSearchId', cvSearchId)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/continue`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(continueCvSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a canonical tag value to a CV Search category. A duplicate value in the same category (case-insensitive) returns 409. 
         * @summary Create a CV Search tag value
         * @param {CreateCvSearchTagRequestDto} createCvSearchTagRequestDto New CV Search tag value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSearchTag: async (createCvSearchTagRequestDto: CreateCvSearchTagRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCvSearchTagRequestDto' is not null or undefined
            assertParamExists('createCvSearchTag', 'createCvSearchTagRequestDto', createCvSearchTagRequestDto)
            const localVarPath = `/api/v1/cv-search/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCvSearchTagRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds an alias (1-60 characters) to an existing tag. Aliases are used for tag lookup with case-insensitive, accent-insensitive matching. A duplicate alias in the same category or a collision with an existing canonical name returns 409. 
         * @summary Add an alias to a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {CreateCvSearchTagAliasRequestDto} createCvSearchTagAliasRequestDto New CV Search tag alias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSearchTagAlias: async (tagValueId: number, createCvSearchTagAliasRequestDto: CreateCvSearchTagAliasRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagValueId' is not null or undefined
            assertParamExists('createCvSearchTagAlias', 'tagValueId', tagValueId)
            // verify required parameter 'createCvSearchTagAliasRequestDto' is not null or undefined
            assertParamExists('createCvSearchTagAlias', 'createCvSearchTagAliasRequestDto', createCvSearchTagAliasRequestDto)
            const localVarPath = `/api/v1/cv-search/tags/{tagValueId}/aliases`
                .replace('{tagValueId}', encodeURIComponent(String(tagValueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCvSearchTagAliasRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a candidate from the CV Search contact list
         * @param {number} cvSearchId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSearchContactListEntry: async (cvSearchId: number, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('deleteCvSearchContactListEntry', 'cvSearchId', cvSearchId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('deleteCvSearchContactListEntry', 'candidateId', candidateId)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/contact-list/{candidateId}`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)))
                .replace('{candidateId}', encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a tag from the CV Search dictionary. CV assignments and aliases are removed with it.
         * @summary Delete a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSearchTag: async (tagValueId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagValueId' is not null or undefined
            assertParamExists('deleteCvSearchTag', 'tagValueId', tagValueId)
            const localVarPath = `/api/v1/cv-search/tags/{tagValueId}`
                .replace('{tagValueId}', encodeURIComponent(String(tagValueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an alias assigned to the given tag value.
         * @summary Delete a CV Search tag alias
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {number} aliasId CV Search tag alias identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSearchTagAlias: async (tagValueId: number, aliasId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagValueId' is not null or undefined
            assertParamExists('deleteCvSearchTagAlias', 'tagValueId', tagValueId)
            // verify required parameter 'aliasId' is not null or undefined
            assertParamExists('deleteCvSearchTagAlias', 'aliasId', aliasId)
            const localVarPath = `/api/v1/cv-search/tags/{tagValueId}/aliases/{aliasId}`
                .replace('{tagValueId}', encodeURIComponent(String(tagValueId)))
                .replace('{aliasId}', encodeURIComponent(String(aliasId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the paginated CV Search contact list
         * @param {number} cvSearchId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {CvSearchContactListStatusDto} [status] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchContactList: async (cvSearchId: number, page?: number, pageSize?: number, status?: CvSearchContactListStatusDto, sortOrder?: SortDirectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('getCvSearchContactList', 'cvSearchId', cvSearchId)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/contact-list`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get CV Search inferred tags for a paused manual process
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchInferredTags: async (cvSearchId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('getCvSearchInferredTags', 'cvSearchId', cvSearchId)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/inferred-tags`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Language proficiency levels (Basic, Intermediate, Advanced, Proficient, Native) from the dedicated CV Search dictionary, sorted by rank. Ids are used as languageLevelTagValueId on tag expression leaves of languages tags (\"at least\" this level). 
         * @summary Get CV Search language levels dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchLanguageLevels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cv-search/language-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated CV Search matches
         * @param {number} cvSearchId 
         * @param {number} [page] 
         * @param {number} [pageSize] Fixed page size for the compact ranking row contract.
         * @param {string} [searchPhrase] 
         * @param {string} [name] Deprecated legacy alias for the candidate name. Used only when searchPhrase is absent.
         * @param {string} [surname] Deprecated legacy alias for the candidate surname. Used only when searchPhrase is absent.
         * @param {number} [minScore] 
         * @param {string} [tagExpression] Boolean tag expression as JSON (URL-encoded), for example &#x60;{\&quot;or\&quot;:[{\&quot;and\&quot;:[{\&quot;tag\&quot;:{\&quot;tagValueId\&quot;:12,\&quot;languageLevelTagValueId\&quot;:34}},{\&quot;not\&quot;:{\&quot;tag\&quot;:{\&quot;tagValueId\&quot;:30}}}]}]}&#x60;. A node has exactly one key: &#x60;and&#x60; | &#x60;or&#x60; | &#x60;not&#x60; | &#x60;tag&#x60;; leaves point to dictionary tag value ids, optionally with a &#x60;languageLevelTagValueId&#x60; language-level pair (that level or above); without the field the language matches on any level. Unknown tag value ids return 400 with the list of &#x60;unknownTagValueIds&#x60;; &#x60;languageLevelTagValueId&#x60; values outside the language level category return 400 with &#x60;invalidLanguageLevelTagValueIds&#x60;. 
         * @param {string} [city] 
         * @param {number} [minExperienceMonths] 
         * @param {CvSearchMatchesSortByDto} [sortBy] 
         * @param {string} [countryCode] 
         * @param {string} [regionCode] 
         * @param {number} [cityId] 
         * @param {GetCvSearchMatchesRadiusKmEnum} [radiusKm] 
         * @param {boolean} [includeUnrecognizedLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchMatches: async (cvSearchId: number, page?: number, pageSize?: number, searchPhrase?: string, name?: string, surname?: string, minScore?: number, tagExpression?: string, city?: string, minExperienceMonths?: number, sortBy?: CvSearchMatchesSortByDto, countryCode?: string, regionCode?: string, cityId?: number, radiusKm?: GetCvSearchMatchesRadiusKmEnum, includeUnrecognizedLocation?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('getCvSearchMatches', 'cvSearchId', cvSearchId)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/matches`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchPhrase !== undefined) {
                localVarQueryParameter['searchPhrase'] = searchPhrase;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (surname !== undefined) {
                localVarQueryParameter['surname'] = surname;
            }

            if (minScore !== undefined) {
                localVarQueryParameter['minScore'] = minScore;
            }

            if (tagExpression !== undefined) {
                localVarQueryParameter['tagExpression'] = tagExpression;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (minExperienceMonths !== undefined) {
                localVarQueryParameter['minExperienceMonths'] = minExperienceMonths;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }

            if (regionCode !== undefined) {
                localVarQueryParameter['regionCode'] = regionCode;
            }

            if (cityId !== undefined) {
                localVarQueryParameter['cityId'] = cityId;
            }

            if (radiusKm !== undefined) {
                localVarQueryParameter['radiusKm'] = radiusKm;
            }

            if (includeUnrecognizedLocation !== undefined) {
                localVarQueryParameter['includeUnrecognizedLocation'] = includeUnrecognizedLocation;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user\'s CV Search process details
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchProcessDetails: async (cvSearchId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('getCvSearchProcessDetails', 'cvSearchId', cvSearchId)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get CV Search candidate results
         * @param {number} cvSearchId 
         * @param {CvSearchStepNameDto} [step] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchResults: async (cvSearchId: number, step?: CvSearchStepNameDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('getCvSearchResults', 'cvSearchId', cvSearchId)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/results`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get CV Search tag dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cv-search/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Status and candidate count of the default CV Search, read live from CV Search. candidatesCount is the number of candidates matching the tag expression after the latest finished structural filter step, absent until that step finishes. defaultCvSearch is absent when the process has no default CV Search. When CV Search is unreachable the request fails with an error status. Readable by any authenticated user, like the process details; changing the default stays limited to the process owner.
         * @summary Get the default CV Search of a recruitment process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDefaultCvSearch: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessDefaultCvSearch', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/cv-search/default`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tags (without the languages category) and must-have / nice-to-have keywords come from the job description analysis of the default CV Search; they stay empty while it is RUNNING, after an ERROR, without a default CV Search or when CV Search is unreachable. Languages and location are mapped from the process deterministically and are always returned: languages unknown to CV Search are listed in unrecognizedLanguages, a location outside the location taxonomy has status UNRECOGNIZED. The response is built on every call (dictionary lookups per language), so poll the default CV Search status instead and reload the proposal once it is PAUSED.
         * @summary Suggested criteria of the default CV Search for the process configuration wizard
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDefaultCvSearchProposal: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessDefaultCvSearchProposal', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/cv-search/default/proposal`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user\'s CV Search processes
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {CvSearchProcessSearchSortByDto} [sortBy] 
         * @param {string} [name] 
         * @param {Array<CvSearchProcessStatusDto>} [statuses] 
         * @param {string} [createdBy] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [processId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvSearchProcesses: async (pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: CvSearchProcessSearchSortByDto, name?: string, statuses?: Array<CvSearchProcessStatusDto>, createdBy?: string, dateFrom?: string, dateTo?: string, processId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('listCvSearchProcesses', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('listCvSearchProcesses', 'page', page)
            const localVarPath = `/api/v1/cv-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses.join(COLLECTION_FORMATS.csv);
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['createdBy'] = createdBy;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }

            if (processId !== undefined) {
                localVarQueryParameter['processId'] = processId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces one or more source tags with a target tag in the same category. CV assignments and aliases are rewritten onto the target, then source tags are deleted. 
         * @summary Merge CV Search tag values
         * @param {MergeCvSearchTagsRequestDto} mergeCvSearchTagsRequestDto Source tags to replace with a target tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeCvSearchTags: async (mergeCvSearchTagsRequestDto: MergeCvSearchTagsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mergeCvSearchTagsRequestDto' is not null or undefined
            assertParamExists('mergeCvSearchTags', 'mergeCvSearchTagsRequestDto', mergeCvSearchTagsRequestDto)
            const localVarPath = `/api/v1/cv-search/tags/merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeCvSearchTagsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Synchronous preview for the tag editor. Ranking: number of matched optional tags (tags under an OR and not under NOT); required (AND-only) and excluded tags are not counted. With cvSearchId of a search started from a recruitment process, that process\' candidates are excluded. 
         * @summary Live preview of candidates matching the tag expression (no process, no AI)
         * @param {PreviewCvSearchRequestDto} previewCvSearchRequestDto CV Search live preview criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewCvSearch: async (previewCvSearchRequestDto: PreviewCvSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'previewCvSearchRequestDto' is not null or undefined
            assertParamExists('previewCvSearch', 'previewCvSearchRequestDto', previewCvSearchRequestDto)
            const localVarPath = `/api/v1/cv-search/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewCvSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retry after a failed creation or analysis. Starts a new CV Search from the process (job description analysis only) and makes it the default; the previous default stays on the list without the flag. Failures of CV Search are returned as errors. defaultCvSearch is absent when the process has no job description.
         * @summary Create a new default CV Search for a recruitment process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recreateProcessDefaultCvSearch: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('recreateProcessDefaultCvSearch', 'processId', processId)
            const localVarPath = `/api/v1/processes/{processId}/cv-search/default`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changes only the name shown in the application; the search criteria and results stay untouched.
         * @summary Rename a CV Search in any status
         * @param {number} cvSearchId 
         * @param {RenameCvSearchRequestDto} renameCvSearchRequestDto New CV Search name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameCvSearch: async (cvSearchId: number, renameCvSearchRequestDto: RenameCvSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('renameCvSearch', 'cvSearchId', cvSearchId)
            // verify required parameter 'renameCvSearchRequestDto' is not null or undefined
            assertParamExists('renameCvSearch', 'renameCvSearchRequestDto', renameCvSearchRequestDto)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/name`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameCvSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rewind CV Search process to inferred tags review
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewindCvSearchProcessToInferredTags: async (cvSearchId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('rewindCvSearchProcessToInferredTags', 'cvSearchId', cvSearchId)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/rewind-to-tags`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search CV Search tags with pagination
         * @param {number} pageSize 
         * @param {number} page 
         * @param {string} [searchPhrase] 
         * @param {string} [category] Restrict results to one tag category code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCvSearchTags: async (pageSize: number, page: number, searchPhrase?: string, category?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchCvSearchTags', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchCvSearchTags', 'page', page)
            const localVarPath = `/api/v1/cv-search/tags/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (searchPhrase !== undefined) {
                localVarQueryParameter['searchPhrase'] = searchPhrase;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Puts the tag into the group of `parentId` or removes it from its group (`parentId: null`). A tag expression leaf pointing at the parent also matches its children; children stay separate tags. The parent must be in the same category and not be a child itself, the tag must not be a group parent (otherwise 400). 
         * @summary Set or clear the group parent of a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {SetCvSearchTagParentRequestDto} setCvSearchTagParentRequestDto Group parent of a CV Search tag value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCvSearchTagParent: async (tagValueId: number, setCvSearchTagParentRequestDto: SetCvSearchTagParentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagValueId' is not null or undefined
            assertParamExists('setCvSearchTagParent', 'tagValueId', tagValueId)
            // verify required parameter 'setCvSearchTagParentRequestDto' is not null or undefined
            assertParamExists('setCvSearchTagParent', 'setCvSearchTagParentRequestDto', setCvSearchTagParentRequestDto)
            const localVarPath = `/api/v1/cv-search/tags/{tagValueId}/parent`
                .replace('{tagValueId}', encodeURIComponent(String(tagValueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCvSearchTagParentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the current default CV Search of the linked recruitment process. Fails with 400 when the CV Search is not linked to a recruitment process.
         * @summary Set a CV Search as the default of its recruitment process
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultCvSearch: async (cvSearchId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('setDefaultCvSearch', 'cvSearchId', cvSearchId)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/default`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start CV Search from manual criteria
         * @param {StartCvSearchRequestDto} startCvSearchRequestDto CV Search manual start criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCvSearch: async (startCvSearchRequestDto: StartCvSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startCvSearchRequestDto' is not null or undefined
            assertParamExists('startCvSearch', 'startCvSearchRequestDto', startCvSearchRequestDto)
            const localVarPath = `/api/v1/cv-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCvSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start CV Search from a recruitment process
         * @param {string} processId 
         * @param {StartCvSearchFromProcessRequestDto} startCvSearchFromProcessRequestDto CV Search process details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCvSearchFromProcess: async (processId: string, startCvSearchFromProcessRequestDto: StartCvSearchFromProcessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('startCvSearchFromProcess', 'processId', processId)
            // verify required parameter 'startCvSearchFromProcessRequestDto' is not null or undefined
            assertParamExists('startCvSearchFromProcess', 'startCvSearchFromProcessRequestDto', startCvSearchFromProcessRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/cv-search`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCvSearchFromProcessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a CV Search contact list status
         * @param {number} cvSearchId 
         * @param {string} candidateId 
         * @param {UpdateCvSearchContactListStatusRequestDto} updateCvSearchContactListStatusRequestDto CV Search contact list status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchContactListStatus: async (cvSearchId: number, candidateId: string, updateCvSearchContactListStatusRequestDto: UpdateCvSearchContactListStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('updateCvSearchContactListStatus', 'cvSearchId', cvSearchId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('updateCvSearchContactListStatus', 'candidateId', candidateId)
            // verify required parameter 'updateCvSearchContactListStatusRequestDto' is not null or undefined
            assertParamExists('updateCvSearchContactListStatus', 'updateCvSearchContactListStatusRequestDto', updateCvSearchContactListStatusRequestDto)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/contact-list/{candidateId}/status`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)))
                .replace('{candidateId}', encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCvSearchContactListStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Full replacement: tagExpression, location and keywords are always overwritten - send the whole editor state. Omitted or blank name keeps the current name. Omitted jobDescription keeps it, empty string clears it. 
         * @summary Save all criteria of a paused CV Search (tags, location, keywords, JD, name)
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchCriteriaRequestDto} updateCvSearchCriteriaRequestDto CV Search criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchCriteria: async (cvSearchId: number, updateCvSearchCriteriaRequestDto: UpdateCvSearchCriteriaRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('updateCvSearchCriteria', 'cvSearchId', cvSearchId)
            // verify required parameter 'updateCvSearchCriteriaRequestDto' is not null or undefined
            assertParamExists('updateCvSearchCriteria', 'updateCvSearchCriteriaRequestDto', updateCvSearchCriteriaRequestDto)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/criteria`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCvSearchCriteriaRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update CV Search JD keywords before continuing the process
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchJdKeywordsRequestDto} updateCvSearchJdKeywordsRequestDto CV Search JD keywords update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchJdKeywords: async (cvSearchId: number, updateCvSearchJdKeywordsRequestDto: UpdateCvSearchJdKeywordsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('updateCvSearchJdKeywords', 'cvSearchId', cvSearchId)
            // verify required parameter 'updateCvSearchJdKeywordsRequestDto' is not null or undefined
            assertParamExists('updateCvSearchJdKeywords', 'updateCvSearchJdKeywordsRequestDto', updateCvSearchJdKeywordsRequestDto)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/jd-keywords`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCvSearchJdKeywordsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update CV Search location criteria before continuing the process
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchLocationCriteriaRequestDto} updateCvSearchLocationCriteriaRequestDto CV Search location criteria update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchLocationCriteria: async (cvSearchId: number, updateCvSearchLocationCriteriaRequestDto: UpdateCvSearchLocationCriteriaRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('updateCvSearchLocationCriteria', 'cvSearchId', cvSearchId)
            // verify required parameter 'updateCvSearchLocationCriteriaRequestDto' is not null or undefined
            assertParamExists('updateCvSearchLocationCriteria', 'updateCvSearchLocationCriteriaRequestDto', updateCvSearchLocationCriteriaRequestDto)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/location-criteria`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCvSearchLocationCriteriaRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changes the canonical name of an existing tag. The identifier stays the same. A name conflict in the same category returns 409. 
         * @summary Rename a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {UpdateCvSearchTagRequestDto} updateCvSearchTagRequestDto Renamed CV Search tag value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchTag: async (tagValueId: number, updateCvSearchTagRequestDto: UpdateCvSearchTagRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagValueId' is not null or undefined
            assertParamExists('updateCvSearchTag', 'tagValueId', tagValueId)
            // verify required parameter 'updateCvSearchTagRequestDto' is not null or undefined
            assertParamExists('updateCvSearchTag', 'updateCvSearchTagRequestDto', updateCvSearchTagRequestDto)
            const localVarPath = `/api/v1/cv-search/tags/{tagValueId}`
                .replace('{tagValueId}', encodeURIComponent(String(tagValueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCvSearchTagRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save the CV Search tag expression before continuing the process
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchTagExpressionRequestDto} updateCvSearchTagExpressionRequestDto CV Search tag expression update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchTagExpression: async (cvSearchId: number, updateCvSearchTagExpressionRequestDto: UpdateCvSearchTagExpressionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvSearchId' is not null or undefined
            assertParamExists('updateCvSearchTagExpression', 'cvSearchId', cvSearchId)
            // verify required parameter 'updateCvSearchTagExpressionRequestDto' is not null or undefined
            assertParamExists('updateCvSearchTagExpression', 'updateCvSearchTagExpressionRequestDto', updateCvSearchTagExpressionRequestDto)
            const localVarPath = `/api/v1/cv-search/{cvSearchId}/tag-expression`
                .replace('{cvSearchId}', encodeURIComponent(String(cvSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCvSearchTagExpressionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessesCvSearchRestApi - functional programming interface
 */
export const ProcessesCvSearchRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessesCvSearchRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a candidate to the CV Search contact list
         * @param {number} cvSearchId 
         * @param {AddCvSearchContactListEntryRequestDto} addCvSearchContactListEntryRequestDto Candidate to add to the CV Search contact list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCvSearchContactListEntry(cvSearchId: number, addCvSearchContactListEntryRequestDto: AddCvSearchContactListEntryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchContactListItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCvSearchContactListEntry(cvSearchId, addCvSearchContactListEntryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.addCvSearchContactListEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used when the CV Search step of the process configuration is skipped; the CV Search itself stays on the list.
         * @summary Leave a recruitment process without a default CV Search
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearProcessDefaultCvSearch(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.clearProcessDefaultCvSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Continue a paused CV Search process
         * @param {number} cvSearchId 
         * @param {ContinueCvSearchRequestDto} [continueCvSearchRequestDto] Continue CV Search process details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async continueCvSearch(cvSearchId: number, continueCvSearchRequestDto?: ContinueCvSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinueCvSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.continueCvSearch(cvSearchId, continueCvSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.continueCvSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds a canonical tag value to a CV Search category. A duplicate value in the same category (case-insensitive) returns 409. 
         * @summary Create a CV Search tag value
         * @param {CreateCvSearchTagRequestDto} createCvSearchTagRequestDto New CV Search tag value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSearchTag(createCvSearchTagRequestDto: CreateCvSearchTagRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchTagValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCvSearchTag(createCvSearchTagRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.createCvSearchTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds an alias (1-60 characters) to an existing tag. Aliases are used for tag lookup with case-insensitive, accent-insensitive matching. A duplicate alias in the same category or a collision with an existing canonical name returns 409. 
         * @summary Add an alias to a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {CreateCvSearchTagAliasRequestDto} createCvSearchTagAliasRequestDto New CV Search tag alias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCvSearchTagAlias(tagValueId: number, createCvSearchTagAliasRequestDto: CreateCvSearchTagAliasRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchTagAliasDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCvSearchTagAlias(tagValueId, createCvSearchTagAliasRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.createCvSearchTagAlias']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a candidate from the CV Search contact list
         * @param {number} cvSearchId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSearchContactListEntry(cvSearchId: number, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCvSearchContactListEntry(cvSearchId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.deleteCvSearchContactListEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a tag from the CV Search dictionary. CV assignments and aliases are removed with it.
         * @summary Delete a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSearchTag(tagValueId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCvSearchTag(tagValueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.deleteCvSearchTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes an alias assigned to the given tag value.
         * @summary Delete a CV Search tag alias
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {number} aliasId CV Search tag alias identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCvSearchTagAlias(tagValueId: number, aliasId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCvSearchTagAlias(tagValueId, aliasId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.deleteCvSearchTagAlias']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the paginated CV Search contact list
         * @param {number} cvSearchId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {CvSearchContactListStatusDto} [status] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchContactList(cvSearchId: number, page?: number, pageSize?: number, status?: CvSearchContactListStatusDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCvSearchContactListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchContactList(cvSearchId, page, pageSize, status, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.getCvSearchContactList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get CV Search inferred tags for a paused manual process
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchInferredTags(cvSearchId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCvSearchInferredTagsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchInferredTags(cvSearchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.getCvSearchInferredTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Language proficiency levels (Basic, Intermediate, Advanced, Proficient, Native) from the dedicated CV Search dictionary, sorted by rank. Ids are used as languageLevelTagValueId on tag expression leaves of languages tags (\"at least\" this level). 
         * @summary Get CV Search language levels dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchLanguageLevels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCvSearchLanguageLevelsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchLanguageLevels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.getCvSearchLanguageLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated CV Search matches
         * @param {number} cvSearchId 
         * @param {number} [page] 
         * @param {number} [pageSize] Fixed page size for the compact ranking row contract.
         * @param {string} [searchPhrase] 
         * @param {string} [name] Deprecated legacy alias for the candidate name. Used only when searchPhrase is absent.
         * @param {string} [surname] Deprecated legacy alias for the candidate surname. Used only when searchPhrase is absent.
         * @param {number} [minScore] 
         * @param {string} [tagExpression] Boolean tag expression as JSON (URL-encoded), for example &#x60;{\&quot;or\&quot;:[{\&quot;and\&quot;:[{\&quot;tag\&quot;:{\&quot;tagValueId\&quot;:12,\&quot;languageLevelTagValueId\&quot;:34}},{\&quot;not\&quot;:{\&quot;tag\&quot;:{\&quot;tagValueId\&quot;:30}}}]}]}&#x60;. A node has exactly one key: &#x60;and&#x60; | &#x60;or&#x60; | &#x60;not&#x60; | &#x60;tag&#x60;; leaves point to dictionary tag value ids, optionally with a &#x60;languageLevelTagValueId&#x60; language-level pair (that level or above); without the field the language matches on any level. Unknown tag value ids return 400 with the list of &#x60;unknownTagValueIds&#x60;; &#x60;languageLevelTagValueId&#x60; values outside the language level category return 400 with &#x60;invalidLanguageLevelTagValueIds&#x60;. 
         * @param {string} [city] 
         * @param {number} [minExperienceMonths] 
         * @param {CvSearchMatchesSortByDto} [sortBy] 
         * @param {string} [countryCode] 
         * @param {string} [regionCode] 
         * @param {number} [cityId] 
         * @param {GetCvSearchMatchesRadiusKmEnum} [radiusKm] 
         * @param {boolean} [includeUnrecognizedLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchMatches(cvSearchId: number, page?: number, pageSize?: number, searchPhrase?: string, name?: string, surname?: string, minScore?: number, tagExpression?: string, city?: string, minExperienceMonths?: number, sortBy?: CvSearchMatchesSortByDto, countryCode?: string, regionCode?: string, cityId?: number, radiusKm?: GetCvSearchMatchesRadiusKmEnum, includeUnrecognizedLocation?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCvSearchMatchesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchMatches(cvSearchId, page, pageSize, searchPhrase, name, surname, minScore, tagExpression, city, minExperienceMonths, sortBy, countryCode, regionCode, cityId, radiusKm, includeUnrecognizedLocation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.getCvSearchMatches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current user\'s CV Search process details
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchProcessDetails(cvSearchId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCvSearchProcessDetailsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchProcessDetails(cvSearchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.getCvSearchProcessDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get CV Search candidate results
         * @param {number} cvSearchId 
         * @param {CvSearchStepNameDto} [step] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchResults(cvSearchId: number, step?: CvSearchStepNameDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCvSearchResultsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchResults(cvSearchId, step, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.getCvSearchResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get CV Search tag dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchTags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCvSearchTagsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchTags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.getCvSearchTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Status and candidate count of the default CV Search, read live from CV Search. candidatesCount is the number of candidates matching the tag expression after the latest finished structural filter step, absent until that step finishes. defaultCvSearch is absent when the process has no default CV Search. When CV Search is unreachable the request fails with an error status. Readable by any authenticated user, like the process details; changing the default stays limited to the process owner.
         * @summary Get the default CV Search of a recruitment process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProcessDefaultCvSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessDefaultCvSearch(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.getProcessDefaultCvSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Tags (without the languages category) and must-have / nice-to-have keywords come from the job description analysis of the default CV Search; they stay empty while it is RUNNING, after an ERROR, without a default CV Search or when CV Search is unreachable. Languages and location are mapped from the process deterministically and are always returned: languages unknown to CV Search are listed in unrecognizedLanguages, a location outside the location taxonomy has status UNRECOGNIZED. The response is built on every call (dictionary lookups per language), so poll the default CV Search status instead and reload the proposal once it is PAUSED.
         * @summary Suggested criteria of the default CV Search for the process configuration wizard
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessDefaultCvSearchProposal(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessDefaultCvSearchProposalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessDefaultCvSearchProposal(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.getProcessDefaultCvSearchProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current user\'s CV Search processes
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {CvSearchProcessSearchSortByDto} [sortBy] 
         * @param {string} [name] 
         * @param {Array<CvSearchProcessStatusDto>} [statuses] 
         * @param {string} [createdBy] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [processId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCvSearchProcesses(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: CvSearchProcessSearchSortByDto, name?: string, statuses?: Array<CvSearchProcessStatusDto>, createdBy?: string, dateFrom?: string, dateTo?: string, processId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchProcessSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCvSearchProcesses(pageSize, page, sortOrder, sortBy, name, statuses, createdBy, dateFrom, dateTo, processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.listCvSearchProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces one or more source tags with a target tag in the same category. CV assignments and aliases are rewritten onto the target, then source tags are deleted. 
         * @summary Merge CV Search tag values
         * @param {MergeCvSearchTagsRequestDto} mergeCvSearchTagsRequestDto Source tags to replace with a target tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeCvSearchTags(mergeCvSearchTagsRequestDto: MergeCvSearchTagsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchTagValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeCvSearchTags(mergeCvSearchTagsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.mergeCvSearchTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Synchronous preview for the tag editor. Ranking: number of matched optional tags (tags under an OR and not under NOT); required (AND-only) and excluded tags are not counted. With cvSearchId of a search started from a recruitment process, that process\' candidates are excluded. 
         * @summary Live preview of candidates matching the tag expression (no process, no AI)
         * @param {PreviewCvSearchRequestDto} previewCvSearchRequestDto CV Search live preview criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewCvSearch(previewCvSearchRequestDto: PreviewCvSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewCvSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewCvSearch(previewCvSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.previewCvSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retry after a failed creation or analysis. Starts a new CV Search from the process (job description analysis only) and makes it the default; the previous default stays on the list without the flag. Failures of CV Search are returned as errors. defaultCvSearch is absent when the process has no job description.
         * @summary Create a new default CV Search for a recruitment process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recreateProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProcessDefaultCvSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recreateProcessDefaultCvSearch(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.recreateProcessDefaultCvSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Changes only the name shown in the application; the search criteria and results stay untouched.
         * @summary Rename a CV Search in any status
         * @param {number} cvSearchId 
         * @param {RenameCvSearchRequestDto} renameCvSearchRequestDto New CV Search name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameCvSearch(cvSearchId: number, renameCvSearchRequestDto: RenameCvSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameCvSearch(cvSearchId, renameCvSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.renameCvSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rewind CV Search process to inferred tags review
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rewindCvSearchProcessToInferredTags(cvSearchId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinueCvSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rewindCvSearchProcessToInferredTags(cvSearchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.rewindCvSearchProcessToInferredTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search CV Search tags with pagination
         * @param {number} pageSize 
         * @param {number} page 
         * @param {string} [searchPhrase] 
         * @param {string} [category] Restrict results to one tag category code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCvSearchTags(pageSize: number, page: number, searchPhrase?: string, category?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchCvSearchTagsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCvSearchTags(pageSize, page, searchPhrase, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.searchCvSearchTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Puts the tag into the group of `parentId` or removes it from its group (`parentId: null`). A tag expression leaf pointing at the parent also matches its children; children stay separate tags. The parent must be in the same category and not be a child itself, the tag must not be a group parent (otherwise 400). 
         * @summary Set or clear the group parent of a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {SetCvSearchTagParentRequestDto} setCvSearchTagParentRequestDto Group parent of a CV Search tag value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCvSearchTagParent(tagValueId: number, setCvSearchTagParentRequestDto: SetCvSearchTagParentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchTagValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCvSearchTagParent(tagValueId, setCvSearchTagParentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.setCvSearchTagParent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the current default CV Search of the linked recruitment process. Fails with 400 when the CV Search is not linked to a recruitment process.
         * @summary Set a CV Search as the default of its recruitment process
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefaultCvSearch(cvSearchId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDefaultCvSearch(cvSearchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.setDefaultCvSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start CV Search from manual criteria
         * @param {StartCvSearchRequestDto} startCvSearchRequestDto CV Search manual start criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startCvSearch(startCvSearchRequestDto: StartCvSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartCvSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startCvSearch(startCvSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.startCvSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start CV Search from a recruitment process
         * @param {string} processId 
         * @param {StartCvSearchFromProcessRequestDto} startCvSearchFromProcessRequestDto CV Search process details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startCvSearchFromProcess(processId: string, startCvSearchFromProcessRequestDto: StartCvSearchFromProcessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartCvSearchFromProcessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startCvSearchFromProcess(processId, startCvSearchFromProcessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.startCvSearchFromProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a CV Search contact list status
         * @param {number} cvSearchId 
         * @param {string} candidateId 
         * @param {UpdateCvSearchContactListStatusRequestDto} updateCvSearchContactListStatusRequestDto CV Search contact list status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSearchContactListStatus(cvSearchId: number, candidateId: string, updateCvSearchContactListStatusRequestDto: UpdateCvSearchContactListStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchContactListItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCvSearchContactListStatus(cvSearchId, candidateId, updateCvSearchContactListStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.updateCvSearchContactListStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Full replacement: tagExpression, location and keywords are always overwritten - send the whole editor state. Omitted or blank name keeps the current name. Omitted jobDescription keeps it, empty string clears it. 
         * @summary Save all criteria of a paused CV Search (tags, location, keywords, JD, name)
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchCriteriaRequestDto} updateCvSearchCriteriaRequestDto CV Search criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSearchCriteria(cvSearchId: number, updateCvSearchCriteriaRequestDto: UpdateCvSearchCriteriaRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCvSearchProcessDetailsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCvSearchCriteria(cvSearchId, updateCvSearchCriteriaRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.updateCvSearchCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update CV Search JD keywords before continuing the process
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchJdKeywordsRequestDto} updateCvSearchJdKeywordsRequestDto CV Search JD keywords update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSearchJdKeywords(cvSearchId: number, updateCvSearchJdKeywordsRequestDto: UpdateCvSearchJdKeywordsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCvSearchJdKeywordsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCvSearchJdKeywords(cvSearchId, updateCvSearchJdKeywordsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.updateCvSearchJdKeywords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update CV Search location criteria before continuing the process
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchLocationCriteriaRequestDto} updateCvSearchLocationCriteriaRequestDto CV Search location criteria update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSearchLocationCriteria(cvSearchId: number, updateCvSearchLocationCriteriaRequestDto: UpdateCvSearchLocationCriteriaRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCvSearchLocationCriteriaResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCvSearchLocationCriteria(cvSearchId, updateCvSearchLocationCriteriaRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.updateCvSearchLocationCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Changes the canonical name of an existing tag. The identifier stays the same. A name conflict in the same category returns 409. 
         * @summary Rename a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {UpdateCvSearchTagRequestDto} updateCvSearchTagRequestDto Renamed CV Search tag value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSearchTag(tagValueId: number, updateCvSearchTagRequestDto: UpdateCvSearchTagRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchTagValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCvSearchTag(tagValueId, updateCvSearchTagRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.updateCvSearchTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save the CV Search tag expression before continuing the process
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchTagExpressionRequestDto} updateCvSearchTagExpressionRequestDto CV Search tag expression update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCvSearchTagExpression(cvSearchId: number, updateCvSearchTagExpressionRequestDto: UpdateCvSearchTagExpressionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCvSearchTagExpressionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCvSearchTagExpression(cvSearchId, updateCvSearchTagExpressionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvSearchRestApi.updateCvSearchTagExpression']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessesCvSearchRestApi - factory interface
 */
export const ProcessesCvSearchRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessesCvSearchRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a candidate to the CV Search contact list
         * @param {number} cvSearchId 
         * @param {AddCvSearchContactListEntryRequestDto} addCvSearchContactListEntryRequestDto Candidate to add to the CV Search contact list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCvSearchContactListEntry(cvSearchId: number, addCvSearchContactListEntryRequestDto: AddCvSearchContactListEntryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchContactListItemDto> {
            return localVarFp.addCvSearchContactListEntry(cvSearchId, addCvSearchContactListEntryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Used when the CV Search step of the process configuration is skipped; the CV Search itself stays on the list.
         * @summary Leave a recruitment process without a default CV Search
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clearProcessDefaultCvSearch(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Continue a paused CV Search process
         * @param {number} cvSearchId 
         * @param {ContinueCvSearchRequestDto} [continueCvSearchRequestDto] Continue CV Search process details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueCvSearch(cvSearchId: number, continueCvSearchRequestDto?: ContinueCvSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContinueCvSearchResponseDto> {
            return localVarFp.continueCvSearch(cvSearchId, continueCvSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds a canonical tag value to a CV Search category. A duplicate value in the same category (case-insensitive) returns 409. 
         * @summary Create a CV Search tag value
         * @param {CreateCvSearchTagRequestDto} createCvSearchTagRequestDto New CV Search tag value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSearchTag(createCvSearchTagRequestDto: CreateCvSearchTagRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchTagValueDto> {
            return localVarFp.createCvSearchTag(createCvSearchTagRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds an alias (1-60 characters) to an existing tag. Aliases are used for tag lookup with case-insensitive, accent-insensitive matching. A duplicate alias in the same category or a collision with an existing canonical name returns 409. 
         * @summary Add an alias to a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {CreateCvSearchTagAliasRequestDto} createCvSearchTagAliasRequestDto New CV Search tag alias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCvSearchTagAlias(tagValueId: number, createCvSearchTagAliasRequestDto: CreateCvSearchTagAliasRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchTagAliasDto> {
            return localVarFp.createCvSearchTagAlias(tagValueId, createCvSearchTagAliasRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a candidate from the CV Search contact list
         * @param {number} cvSearchId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSearchContactListEntry(cvSearchId: number, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCvSearchContactListEntry(cvSearchId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a tag from the CV Search dictionary. CV assignments and aliases are removed with it.
         * @summary Delete a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSearchTag(tagValueId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCvSearchTag(tagValueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an alias assigned to the given tag value.
         * @summary Delete a CV Search tag alias
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {number} aliasId CV Search tag alias identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCvSearchTagAlias(tagValueId: number, aliasId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCvSearchTagAlias(tagValueId, aliasId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the paginated CV Search contact list
         * @param {number} cvSearchId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {CvSearchContactListStatusDto} [status] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchContactList(cvSearchId: number, page?: number, pageSize?: number, status?: CvSearchContactListStatusDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchContactListResponseDto> {
            return localVarFp.getCvSearchContactList(cvSearchId, page, pageSize, status, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get CV Search inferred tags for a paused manual process
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchInferredTags(cvSearchId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchInferredTagsResponseDto> {
            return localVarFp.getCvSearchInferredTags(cvSearchId, options).then((request) => request(axios, basePath));
        },
        /**
         * Language proficiency levels (Basic, Intermediate, Advanced, Proficient, Native) from the dedicated CV Search dictionary, sorted by rank. Ids are used as languageLevelTagValueId on tag expression leaves of languages tags (\"at least\" this level). 
         * @summary Get CV Search language levels dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchLanguageLevels(options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchLanguageLevelsResponseDto> {
            return localVarFp.getCvSearchLanguageLevels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated CV Search matches
         * @param {number} cvSearchId 
         * @param {number} [page] 
         * @param {number} [pageSize] Fixed page size for the compact ranking row contract.
         * @param {string} [searchPhrase] 
         * @param {string} [name] Deprecated legacy alias for the candidate name. Used only when searchPhrase is absent.
         * @param {string} [surname] Deprecated legacy alias for the candidate surname. Used only when searchPhrase is absent.
         * @param {number} [minScore] 
         * @param {string} [tagExpression] Boolean tag expression as JSON (URL-encoded), for example &#x60;{\&quot;or\&quot;:[{\&quot;and\&quot;:[{\&quot;tag\&quot;:{\&quot;tagValueId\&quot;:12,\&quot;languageLevelTagValueId\&quot;:34}},{\&quot;not\&quot;:{\&quot;tag\&quot;:{\&quot;tagValueId\&quot;:30}}}]}]}&#x60;. A node has exactly one key: &#x60;and&#x60; | &#x60;or&#x60; | &#x60;not&#x60; | &#x60;tag&#x60;; leaves point to dictionary tag value ids, optionally with a &#x60;languageLevelTagValueId&#x60; language-level pair (that level or above); without the field the language matches on any level. Unknown tag value ids return 400 with the list of &#x60;unknownTagValueIds&#x60;; &#x60;languageLevelTagValueId&#x60; values outside the language level category return 400 with &#x60;invalidLanguageLevelTagValueIds&#x60;. 
         * @param {string} [city] 
         * @param {number} [minExperienceMonths] 
         * @param {CvSearchMatchesSortByDto} [sortBy] 
         * @param {string} [countryCode] 
         * @param {string} [regionCode] 
         * @param {number} [cityId] 
         * @param {GetCvSearchMatchesRadiusKmEnum} [radiusKm] 
         * @param {boolean} [includeUnrecognizedLocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchMatches(cvSearchId: number, page?: number, pageSize?: number, searchPhrase?: string, name?: string, surname?: string, minScore?: number, tagExpression?: string, city?: string, minExperienceMonths?: number, sortBy?: CvSearchMatchesSortByDto, countryCode?: string, regionCode?: string, cityId?: number, radiusKm?: GetCvSearchMatchesRadiusKmEnum, includeUnrecognizedLocation?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchMatchesResponseDto> {
            return localVarFp.getCvSearchMatches(cvSearchId, page, pageSize, searchPhrase, name, surname, minScore, tagExpression, city, minExperienceMonths, sortBy, countryCode, regionCode, cityId, radiusKm, includeUnrecognizedLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user\'s CV Search process details
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchProcessDetails(cvSearchId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchProcessDetailsResponseDto> {
            return localVarFp.getCvSearchProcessDetails(cvSearchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get CV Search candidate results
         * @param {number} cvSearchId 
         * @param {CvSearchStepNameDto} [step] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchResults(cvSearchId: number, step?: CvSearchStepNameDto, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchResultsResponseDto> {
            return localVarFp.getCvSearchResults(cvSearchId, step, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get CV Search tag dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchTags(options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchTagsResponseDto> {
            return localVarFp.getCvSearchTags(options).then((request) => request(axios, basePath));
        },
        /**
         * Status and candidate count of the default CV Search, read live from CV Search. candidatesCount is the number of candidates matching the tag expression after the latest finished structural filter step, absent until that step finishes. defaultCvSearch is absent when the process has no default CV Search. When CV Search is unreachable the request fails with an error status. Readable by any authenticated user, like the process details; changing the default stays limited to the process owner.
         * @summary Get the default CV Search of a recruitment process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProcessDefaultCvSearchResponseDto> {
            return localVarFp.getProcessDefaultCvSearch(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Tags (without the languages category) and must-have / nice-to-have keywords come from the job description analysis of the default CV Search; they stay empty while it is RUNNING, after an ERROR, without a default CV Search or when CV Search is unreachable. Languages and location are mapped from the process deterministically and are always returned: languages unknown to CV Search are listed in unrecognizedLanguages, a location outside the location taxonomy has status UNRECOGNIZED. The response is built on every call (dictionary lookups per language), so poll the default CV Search status instead and reload the proposal once it is PAUSED.
         * @summary Suggested criteria of the default CV Search for the process configuration wizard
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDefaultCvSearchProposal(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDefaultCvSearchProposalDto> {
            return localVarFp.getProcessDefaultCvSearchProposal(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user\'s CV Search processes
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {CvSearchProcessSearchSortByDto} [sortBy] 
         * @param {string} [name] 
         * @param {Array<CvSearchProcessStatusDto>} [statuses] 
         * @param {string} [createdBy] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [processId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCvSearchProcesses(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: CvSearchProcessSearchSortByDto, name?: string, statuses?: Array<CvSearchProcessStatusDto>, createdBy?: string, dateFrom?: string, dateTo?: string, processId?: string, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchProcessSearchResponseDto> {
            return localVarFp.listCvSearchProcesses(pageSize, page, sortOrder, sortBy, name, statuses, createdBy, dateFrom, dateTo, processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces one or more source tags with a target tag in the same category. CV assignments and aliases are rewritten onto the target, then source tags are deleted. 
         * @summary Merge CV Search tag values
         * @param {MergeCvSearchTagsRequestDto} mergeCvSearchTagsRequestDto Source tags to replace with a target tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeCvSearchTags(mergeCvSearchTagsRequestDto: MergeCvSearchTagsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchTagValueDto> {
            return localVarFp.mergeCvSearchTags(mergeCvSearchTagsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Synchronous preview for the tag editor. Ranking: number of matched optional tags (tags under an OR and not under NOT); required (AND-only) and excluded tags are not counted. With cvSearchId of a search started from a recruitment process, that process\' candidates are excluded. 
         * @summary Live preview of candidates matching the tag expression (no process, no AI)
         * @param {PreviewCvSearchRequestDto} previewCvSearchRequestDto CV Search live preview criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewCvSearch(previewCvSearchRequestDto: PreviewCvSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PreviewCvSearchResponseDto> {
            return localVarFp.previewCvSearch(previewCvSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Retry after a failed creation or analysis. Starts a new CV Search from the process (job description analysis only) and makes it the default; the previous default stays on the list without the flag. Failures of CV Search are returned as errors. defaultCvSearch is absent when the process has no job description.
         * @summary Create a new default CV Search for a recruitment process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recreateProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProcessDefaultCvSearchResponseDto> {
            return localVarFp.recreateProcessDefaultCvSearch(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Changes only the name shown in the application; the search criteria and results stay untouched.
         * @summary Rename a CV Search in any status
         * @param {number} cvSearchId 
         * @param {RenameCvSearchRequestDto} renameCvSearchRequestDto New CV Search name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameCvSearch(cvSearchId: number, renameCvSearchRequestDto: RenameCvSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.renameCvSearch(cvSearchId, renameCvSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rewind CV Search process to inferred tags review
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewindCvSearchProcessToInferredTags(cvSearchId: number, options?: RawAxiosRequestConfig): AxiosPromise<ContinueCvSearchResponseDto> {
            return localVarFp.rewindCvSearchProcessToInferredTags(cvSearchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search CV Search tags with pagination
         * @param {number} pageSize 
         * @param {number} page 
         * @param {string} [searchPhrase] 
         * @param {string} [category] Restrict results to one tag category code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCvSearchTags(pageSize: number, page: number, searchPhrase?: string, category?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchCvSearchTagsResponseDto> {
            return localVarFp.searchCvSearchTags(pageSize, page, searchPhrase, category, options).then((request) => request(axios, basePath));
        },
        /**
         * Puts the tag into the group of `parentId` or removes it from its group (`parentId: null`). A tag expression leaf pointing at the parent also matches its children; children stay separate tags. The parent must be in the same category and not be a child itself, the tag must not be a group parent (otherwise 400). 
         * @summary Set or clear the group parent of a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {SetCvSearchTagParentRequestDto} setCvSearchTagParentRequestDto Group parent of a CV Search tag value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCvSearchTagParent(tagValueId: number, setCvSearchTagParentRequestDto: SetCvSearchTagParentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchTagValueDto> {
            return localVarFp.setCvSearchTagParent(tagValueId, setCvSearchTagParentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the current default CV Search of the linked recruitment process. Fails with 400 when the CV Search is not linked to a recruitment process.
         * @summary Set a CV Search as the default of its recruitment process
         * @param {number} cvSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultCvSearch(cvSearchId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDefaultCvSearch(cvSearchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start CV Search from manual criteria
         * @param {StartCvSearchRequestDto} startCvSearchRequestDto CV Search manual start criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCvSearch(startCvSearchRequestDto: StartCvSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<StartCvSearchResponseDto> {
            return localVarFp.startCvSearch(startCvSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start CV Search from a recruitment process
         * @param {string} processId 
         * @param {StartCvSearchFromProcessRequestDto} startCvSearchFromProcessRequestDto CV Search process details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCvSearchFromProcess(processId: string, startCvSearchFromProcessRequestDto: StartCvSearchFromProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<StartCvSearchFromProcessResponseDto> {
            return localVarFp.startCvSearchFromProcess(processId, startCvSearchFromProcessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a CV Search contact list status
         * @param {number} cvSearchId 
         * @param {string} candidateId 
         * @param {UpdateCvSearchContactListStatusRequestDto} updateCvSearchContactListStatusRequestDto CV Search contact list status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchContactListStatus(cvSearchId: number, candidateId: string, updateCvSearchContactListStatusRequestDto: UpdateCvSearchContactListStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchContactListItemDto> {
            return localVarFp.updateCvSearchContactListStatus(cvSearchId, candidateId, updateCvSearchContactListStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Full replacement: tagExpression, location and keywords are always overwritten - send the whole editor state. Omitted or blank name keeps the current name. Omitted jobDescription keeps it, empty string clears it. 
         * @summary Save all criteria of a paused CV Search (tags, location, keywords, JD, name)
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchCriteriaRequestDto} updateCvSearchCriteriaRequestDto CV Search criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchCriteria(cvSearchId: number, updateCvSearchCriteriaRequestDto: UpdateCvSearchCriteriaRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchProcessDetailsResponseDto> {
            return localVarFp.updateCvSearchCriteria(cvSearchId, updateCvSearchCriteriaRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update CV Search JD keywords before continuing the process
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchJdKeywordsRequestDto} updateCvSearchJdKeywordsRequestDto CV Search JD keywords update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchJdKeywords(cvSearchId: number, updateCvSearchJdKeywordsRequestDto: UpdateCvSearchJdKeywordsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCvSearchJdKeywordsResponseDto> {
            return localVarFp.updateCvSearchJdKeywords(cvSearchId, updateCvSearchJdKeywordsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update CV Search location criteria before continuing the process
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchLocationCriteriaRequestDto} updateCvSearchLocationCriteriaRequestDto CV Search location criteria update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchLocationCriteria(cvSearchId: number, updateCvSearchLocationCriteriaRequestDto: UpdateCvSearchLocationCriteriaRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCvSearchLocationCriteriaResponseDto> {
            return localVarFp.updateCvSearchLocationCriteria(cvSearchId, updateCvSearchLocationCriteriaRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Changes the canonical name of an existing tag. The identifier stays the same. A name conflict in the same category returns 409. 
         * @summary Rename a CV Search tag value
         * @param {number} tagValueId CV Search tag value identifier.
         * @param {UpdateCvSearchTagRequestDto} updateCvSearchTagRequestDto Renamed CV Search tag value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchTag(tagValueId: number, updateCvSearchTagRequestDto: UpdateCvSearchTagRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchTagValueDto> {
            return localVarFp.updateCvSearchTag(tagValueId, updateCvSearchTagRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save the CV Search tag expression before continuing the process
         * @param {number} cvSearchId 
         * @param {UpdateCvSearchTagExpressionRequestDto} updateCvSearchTagExpressionRequestDto CV Search tag expression update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCvSearchTagExpression(cvSearchId: number, updateCvSearchTagExpressionRequestDto: UpdateCvSearchTagExpressionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCvSearchTagExpressionResponseDto> {
            return localVarFp.updateCvSearchTagExpression(cvSearchId, updateCvSearchTagExpressionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessesCvSearchRestApi - interface
 */
export interface ProcessesCvSearchRestApiInterface {
    /**
     * 
     * @summary Add a candidate to the CV Search contact list
     * @param {number} cvSearchId 
     * @param {AddCvSearchContactListEntryRequestDto} addCvSearchContactListEntryRequestDto Candidate to add to the CV Search contact list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCvSearchContactListEntry(cvSearchId: number, addCvSearchContactListEntryRequestDto: AddCvSearchContactListEntryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchContactListItemDto>;

    /**
     * Used when the CV Search step of the process configuration is skipped; the CV Search itself stays on the list.
     * @summary Leave a recruitment process without a default CV Search
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clearProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Continue a paused CV Search process
     * @param {number} cvSearchId 
     * @param {ContinueCvSearchRequestDto} [continueCvSearchRequestDto] Continue CV Search process details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    continueCvSearch(cvSearchId: number, continueCvSearchRequestDto?: ContinueCvSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ContinueCvSearchResponseDto>;

    /**
     * Adds a canonical tag value to a CV Search category. A duplicate value in the same category (case-insensitive) returns 409. 
     * @summary Create a CV Search tag value
     * @param {CreateCvSearchTagRequestDto} createCvSearchTagRequestDto New CV Search tag value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCvSearchTag(createCvSearchTagRequestDto: CreateCvSearchTagRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchTagValueDto>;

    /**
     * Adds an alias (1-60 characters) to an existing tag. Aliases are used for tag lookup with case-insensitive, accent-insensitive matching. A duplicate alias in the same category or a collision with an existing canonical name returns 409. 
     * @summary Add an alias to a CV Search tag value
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {CreateCvSearchTagAliasRequestDto} createCvSearchTagAliasRequestDto New CV Search tag alias
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCvSearchTagAlias(tagValueId: number, createCvSearchTagAliasRequestDto: CreateCvSearchTagAliasRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchTagAliasDto>;

    /**
     * 
     * @summary Remove a candidate from the CV Search contact list
     * @param {number} cvSearchId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCvSearchContactListEntry(cvSearchId: number, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Deletes a tag from the CV Search dictionary. CV assignments and aliases are removed with it.
     * @summary Delete a CV Search tag value
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCvSearchTag(tagValueId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Deletes an alias assigned to the given tag value.
     * @summary Delete a CV Search tag alias
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {number} aliasId CV Search tag alias identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCvSearchTagAlias(tagValueId: number, aliasId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get the paginated CV Search contact list
     * @param {number} cvSearchId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {CvSearchContactListStatusDto} [status] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchContactList(cvSearchId: number, page?: number, pageSize?: number, status?: CvSearchContactListStatusDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchContactListResponseDto>;

    /**
     * 
     * @summary Get CV Search inferred tags for a paused manual process
     * @param {number} cvSearchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchInferredTags(cvSearchId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchInferredTagsResponseDto>;

    /**
     * Language proficiency levels (Basic, Intermediate, Advanced, Proficient, Native) from the dedicated CV Search dictionary, sorted by rank. Ids are used as languageLevelTagValueId on tag expression leaves of languages tags (\"at least\" this level). 
     * @summary Get CV Search language levels dictionary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchLanguageLevels(options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchLanguageLevelsResponseDto>;

    /**
     * 
     * @summary Get paginated CV Search matches
     * @param {number} cvSearchId 
     * @param {number} [page] 
     * @param {number} [pageSize] Fixed page size for the compact ranking row contract.
     * @param {string} [searchPhrase] 
     * @param {string} [name] Deprecated legacy alias for the candidate name. Used only when searchPhrase is absent.
     * @param {string} [surname] Deprecated legacy alias for the candidate surname. Used only when searchPhrase is absent.
     * @param {number} [minScore] 
     * @param {string} [tagExpression] Boolean tag expression as JSON (URL-encoded), for example &#x60;{\&quot;or\&quot;:[{\&quot;and\&quot;:[{\&quot;tag\&quot;:{\&quot;tagValueId\&quot;:12,\&quot;languageLevelTagValueId\&quot;:34}},{\&quot;not\&quot;:{\&quot;tag\&quot;:{\&quot;tagValueId\&quot;:30}}}]}]}&#x60;. A node has exactly one key: &#x60;and&#x60; | &#x60;or&#x60; | &#x60;not&#x60; | &#x60;tag&#x60;; leaves point to dictionary tag value ids, optionally with a &#x60;languageLevelTagValueId&#x60; language-level pair (that level or above); without the field the language matches on any level. Unknown tag value ids return 400 with the list of &#x60;unknownTagValueIds&#x60;; &#x60;languageLevelTagValueId&#x60; values outside the language level category return 400 with &#x60;invalidLanguageLevelTagValueIds&#x60;. 
     * @param {string} [city] 
     * @param {number} [minExperienceMonths] 
     * @param {CvSearchMatchesSortByDto} [sortBy] 
     * @param {string} [countryCode] 
     * @param {string} [regionCode] 
     * @param {number} [cityId] 
     * @param {GetCvSearchMatchesRadiusKmEnum} [radiusKm] 
     * @param {boolean} [includeUnrecognizedLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchMatches(cvSearchId: number, page?: number, pageSize?: number, searchPhrase?: string, name?: string, surname?: string, minScore?: number, tagExpression?: string, city?: string, minExperienceMonths?: number, sortBy?: CvSearchMatchesSortByDto, countryCode?: string, regionCode?: string, cityId?: number, radiusKm?: GetCvSearchMatchesRadiusKmEnum, includeUnrecognizedLocation?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchMatchesResponseDto>;

    /**
     * 
     * @summary Get current user\'s CV Search process details
     * @param {number} cvSearchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchProcessDetails(cvSearchId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchProcessDetailsResponseDto>;

    /**
     * 
     * @summary Get CV Search candidate results
     * @param {number} cvSearchId 
     * @param {CvSearchStepNameDto} [step] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchResults(cvSearchId: number, step?: CvSearchStepNameDto, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchResultsResponseDto>;

    /**
     * 
     * @summary Get CV Search tag dictionary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchTags(options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchTagsResponseDto>;

    /**
     * Status and candidate count of the default CV Search, read live from CV Search. candidatesCount is the number of candidates matching the tag expression after the latest finished structural filter step, absent until that step finishes. defaultCvSearch is absent when the process has no default CV Search. When CV Search is unreachable the request fails with an error status. Readable by any authenticated user, like the process details; changing the default stays limited to the process owner.
     * @summary Get the default CV Search of a recruitment process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProcessDefaultCvSearchResponseDto>;

    /**
     * Tags (without the languages category) and must-have / nice-to-have keywords come from the job description analysis of the default CV Search; they stay empty while it is RUNNING, after an ERROR, without a default CV Search or when CV Search is unreachable. Languages and location are mapped from the process deterministically and are always returned: languages unknown to CV Search are listed in unrecognizedLanguages, a location outside the location taxonomy has status UNRECOGNIZED. The response is built on every call (dictionary lookups per language), so poll the default CV Search status instead and reload the proposal once it is PAUSED.
     * @summary Suggested criteria of the default CV Search for the process configuration wizard
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessDefaultCvSearchProposal(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDefaultCvSearchProposalDto>;

    /**
     * 
     * @summary Get current user\'s CV Search processes
     * @param {number} pageSize 
     * @param {number} page 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {CvSearchProcessSearchSortByDto} [sortBy] 
     * @param {string} [name] 
     * @param {Array<CvSearchProcessStatusDto>} [statuses] 
     * @param {string} [createdBy] 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {string} [processId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCvSearchProcesses(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: CvSearchProcessSearchSortByDto, name?: string, statuses?: Array<CvSearchProcessStatusDto>, createdBy?: string, dateFrom?: string, dateTo?: string, processId?: string, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchProcessSearchResponseDto>;

    /**
     * Replaces one or more source tags with a target tag in the same category. CV assignments and aliases are rewritten onto the target, then source tags are deleted. 
     * @summary Merge CV Search tag values
     * @param {MergeCvSearchTagsRequestDto} mergeCvSearchTagsRequestDto Source tags to replace with a target tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mergeCvSearchTags(mergeCvSearchTagsRequestDto: MergeCvSearchTagsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchTagValueDto>;

    /**
     * Synchronous preview for the tag editor. Ranking: number of matched optional tags (tags under an OR and not under NOT); required (AND-only) and excluded tags are not counted. With cvSearchId of a search started from a recruitment process, that process\' candidates are excluded. 
     * @summary Live preview of candidates matching the tag expression (no process, no AI)
     * @param {PreviewCvSearchRequestDto} previewCvSearchRequestDto CV Search live preview criteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewCvSearch(previewCvSearchRequestDto: PreviewCvSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PreviewCvSearchResponseDto>;

    /**
     * Retry after a failed creation or analysis. Starts a new CV Search from the process (job description analysis only) and makes it the default; the previous default stays on the list without the flag. Failures of CV Search are returned as errors. defaultCvSearch is absent when the process has no job description.
     * @summary Create a new default CV Search for a recruitment process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recreateProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetProcessDefaultCvSearchResponseDto>;

    /**
     * Changes only the name shown in the application; the search criteria and results stay untouched.
     * @summary Rename a CV Search in any status
     * @param {number} cvSearchId 
     * @param {RenameCvSearchRequestDto} renameCvSearchRequestDto New CV Search name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    renameCvSearch(cvSearchId: number, renameCvSearchRequestDto: RenameCvSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Rewind CV Search process to inferred tags review
     * @param {number} cvSearchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewindCvSearchProcessToInferredTags(cvSearchId: number, options?: RawAxiosRequestConfig): AxiosPromise<ContinueCvSearchResponseDto>;

    /**
     * 
     * @summary Search CV Search tags with pagination
     * @param {number} pageSize 
     * @param {number} page 
     * @param {string} [searchPhrase] 
     * @param {string} [category] Restrict results to one tag category code.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCvSearchTags(pageSize: number, page: number, searchPhrase?: string, category?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchCvSearchTagsResponseDto>;

    /**
     * Puts the tag into the group of `parentId` or removes it from its group (`parentId: null`). A tag expression leaf pointing at the parent also matches its children; children stay separate tags. The parent must be in the same category and not be a child itself, the tag must not be a group parent (otherwise 400). 
     * @summary Set or clear the group parent of a CV Search tag value
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {SetCvSearchTagParentRequestDto} setCvSearchTagParentRequestDto Group parent of a CV Search tag value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setCvSearchTagParent(tagValueId: number, setCvSearchTagParentRequestDto: SetCvSearchTagParentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchTagValueDto>;

    /**
     * Replaces the current default CV Search of the linked recruitment process. Fails with 400 when the CV Search is not linked to a recruitment process.
     * @summary Set a CV Search as the default of its recruitment process
     * @param {number} cvSearchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setDefaultCvSearch(cvSearchId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Start CV Search from manual criteria
     * @param {StartCvSearchRequestDto} startCvSearchRequestDto CV Search manual start criteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    startCvSearch(startCvSearchRequestDto: StartCvSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<StartCvSearchResponseDto>;

    /**
     * 
     * @summary Start CV Search from a recruitment process
     * @param {string} processId 
     * @param {StartCvSearchFromProcessRequestDto} startCvSearchFromProcessRequestDto CV Search process details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    startCvSearchFromProcess(processId: string, startCvSearchFromProcessRequestDto: StartCvSearchFromProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<StartCvSearchFromProcessResponseDto>;

    /**
     * 
     * @summary Update a CV Search contact list status
     * @param {number} cvSearchId 
     * @param {string} candidateId 
     * @param {UpdateCvSearchContactListStatusRequestDto} updateCvSearchContactListStatusRequestDto CV Search contact list status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCvSearchContactListStatus(cvSearchId: number, candidateId: string, updateCvSearchContactListStatusRequestDto: UpdateCvSearchContactListStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchContactListItemDto>;

    /**
     * Full replacement: tagExpression, location and keywords are always overwritten - send the whole editor state. Omitted or blank name keeps the current name. Omitted jobDescription keeps it, empty string clears it. 
     * @summary Save all criteria of a paused CV Search (tags, location, keywords, JD, name)
     * @param {number} cvSearchId 
     * @param {UpdateCvSearchCriteriaRequestDto} updateCvSearchCriteriaRequestDto CV Search criteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCvSearchCriteria(cvSearchId: number, updateCvSearchCriteriaRequestDto: UpdateCvSearchCriteriaRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GetCvSearchProcessDetailsResponseDto>;

    /**
     * 
     * @summary Update CV Search JD keywords before continuing the process
     * @param {number} cvSearchId 
     * @param {UpdateCvSearchJdKeywordsRequestDto} updateCvSearchJdKeywordsRequestDto CV Search JD keywords update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCvSearchJdKeywords(cvSearchId: number, updateCvSearchJdKeywordsRequestDto: UpdateCvSearchJdKeywordsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCvSearchJdKeywordsResponseDto>;

    /**
     * 
     * @summary Update CV Search location criteria before continuing the process
     * @param {number} cvSearchId 
     * @param {UpdateCvSearchLocationCriteriaRequestDto} updateCvSearchLocationCriteriaRequestDto CV Search location criteria update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCvSearchLocationCriteria(cvSearchId: number, updateCvSearchLocationCriteriaRequestDto: UpdateCvSearchLocationCriteriaRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCvSearchLocationCriteriaResponseDto>;

    /**
     * Changes the canonical name of an existing tag. The identifier stays the same. A name conflict in the same category returns 409. 
     * @summary Rename a CV Search tag value
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {UpdateCvSearchTagRequestDto} updateCvSearchTagRequestDto Renamed CV Search tag value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCvSearchTag(tagValueId: number, updateCvSearchTagRequestDto: UpdateCvSearchTagRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CvSearchTagValueDto>;

    /**
     * 
     * @summary Save the CV Search tag expression before continuing the process
     * @param {number} cvSearchId 
     * @param {UpdateCvSearchTagExpressionRequestDto} updateCvSearchTagExpressionRequestDto CV Search tag expression update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCvSearchTagExpression(cvSearchId: number, updateCvSearchTagExpressionRequestDto: UpdateCvSearchTagExpressionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCvSearchTagExpressionResponseDto>;

}

/**
 * ProcessesCvSearchRestApi - object-oriented interface
 */
export class ProcessesCvSearchRestApi extends BaseAPI implements ProcessesCvSearchRestApiInterface {
    /**
     * 
     * @summary Add a candidate to the CV Search contact list
     * @param {number} cvSearchId 
     * @param {AddCvSearchContactListEntryRequestDto} addCvSearchContactListEntryRequestDto Candidate to add to the CV Search contact list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCvSearchContactListEntry(cvSearchId: number, addCvSearchContactListEntryRequestDto: AddCvSearchContactListEntryRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).addCvSearchContactListEntry(cvSearchId, addCvSearchContactListEntryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used when the CV Search step of the process configuration is skipped; the CV Search itself stays on the list.
     * @summary Leave a recruitment process without a default CV Search
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public clearProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).clearProcessDefaultCvSearch(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Continue a paused CV Search process
     * @param {number} cvSearchId 
     * @param {ContinueCvSearchRequestDto} [continueCvSearchRequestDto] Continue CV Search process details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public continueCvSearch(cvSearchId: number, continueCvSearchRequestDto?: ContinueCvSearchRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).continueCvSearch(cvSearchId, continueCvSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds a canonical tag value to a CV Search category. A duplicate value in the same category (case-insensitive) returns 409. 
     * @summary Create a CV Search tag value
     * @param {CreateCvSearchTagRequestDto} createCvSearchTagRequestDto New CV Search tag value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCvSearchTag(createCvSearchTagRequestDto: CreateCvSearchTagRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).createCvSearchTag(createCvSearchTagRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds an alias (1-60 characters) to an existing tag. Aliases are used for tag lookup with case-insensitive, accent-insensitive matching. A duplicate alias in the same category or a collision with an existing canonical name returns 409. 
     * @summary Add an alias to a CV Search tag value
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {CreateCvSearchTagAliasRequestDto} createCvSearchTagAliasRequestDto New CV Search tag alias
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCvSearchTagAlias(tagValueId: number, createCvSearchTagAliasRequestDto: CreateCvSearchTagAliasRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).createCvSearchTagAlias(tagValueId, createCvSearchTagAliasRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a candidate from the CV Search contact list
     * @param {number} cvSearchId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCvSearchContactListEntry(cvSearchId: number, candidateId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).deleteCvSearchContactListEntry(cvSearchId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a tag from the CV Search dictionary. CV assignments and aliases are removed with it.
     * @summary Delete a CV Search tag value
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCvSearchTag(tagValueId: number, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).deleteCvSearchTag(tagValueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an alias assigned to the given tag value.
     * @summary Delete a CV Search tag alias
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {number} aliasId CV Search tag alias identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCvSearchTagAlias(tagValueId: number, aliasId: number, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).deleteCvSearchTagAlias(tagValueId, aliasId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the paginated CV Search contact list
     * @param {number} cvSearchId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {CvSearchContactListStatusDto} [status] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchContactList(cvSearchId: number, page?: number, pageSize?: number, status?: CvSearchContactListStatusDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).getCvSearchContactList(cvSearchId, page, pageSize, status, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get CV Search inferred tags for a paused manual process
     * @param {number} cvSearchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchInferredTags(cvSearchId: number, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).getCvSearchInferredTags(cvSearchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Language proficiency levels (Basic, Intermediate, Advanced, Proficient, Native) from the dedicated CV Search dictionary, sorted by rank. Ids are used as languageLevelTagValueId on tag expression leaves of languages tags (\"at least\" this level). 
     * @summary Get CV Search language levels dictionary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchLanguageLevels(options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).getCvSearchLanguageLevels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated CV Search matches
     * @param {number} cvSearchId 
     * @param {number} [page] 
     * @param {number} [pageSize] Fixed page size for the compact ranking row contract.
     * @param {string} [searchPhrase] 
     * @param {string} [name] Deprecated legacy alias for the candidate name. Used only when searchPhrase is absent.
     * @param {string} [surname] Deprecated legacy alias for the candidate surname. Used only when searchPhrase is absent.
     * @param {number} [minScore] 
     * @param {string} [tagExpression] Boolean tag expression as JSON (URL-encoded), for example &#x60;{\&quot;or\&quot;:[{\&quot;and\&quot;:[{\&quot;tag\&quot;:{\&quot;tagValueId\&quot;:12,\&quot;languageLevelTagValueId\&quot;:34}},{\&quot;not\&quot;:{\&quot;tag\&quot;:{\&quot;tagValueId\&quot;:30}}}]}]}&#x60;. A node has exactly one key: &#x60;and&#x60; | &#x60;or&#x60; | &#x60;not&#x60; | &#x60;tag&#x60;; leaves point to dictionary tag value ids, optionally with a &#x60;languageLevelTagValueId&#x60; language-level pair (that level or above); without the field the language matches on any level. Unknown tag value ids return 400 with the list of &#x60;unknownTagValueIds&#x60;; &#x60;languageLevelTagValueId&#x60; values outside the language level category return 400 with &#x60;invalidLanguageLevelTagValueIds&#x60;. 
     * @param {string} [city] 
     * @param {number} [minExperienceMonths] 
     * @param {CvSearchMatchesSortByDto} [sortBy] 
     * @param {string} [countryCode] 
     * @param {string} [regionCode] 
     * @param {number} [cityId] 
     * @param {GetCvSearchMatchesRadiusKmEnum} [radiusKm] 
     * @param {boolean} [includeUnrecognizedLocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchMatches(cvSearchId: number, page?: number, pageSize?: number, searchPhrase?: string, name?: string, surname?: string, minScore?: number, tagExpression?: string, city?: string, minExperienceMonths?: number, sortBy?: CvSearchMatchesSortByDto, countryCode?: string, regionCode?: string, cityId?: number, radiusKm?: GetCvSearchMatchesRadiusKmEnum, includeUnrecognizedLocation?: boolean, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).getCvSearchMatches(cvSearchId, page, pageSize, searchPhrase, name, surname, minScore, tagExpression, city, minExperienceMonths, sortBy, countryCode, regionCode, cityId, radiusKm, includeUnrecognizedLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user\'s CV Search process details
     * @param {number} cvSearchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchProcessDetails(cvSearchId: number, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).getCvSearchProcessDetails(cvSearchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get CV Search candidate results
     * @param {number} cvSearchId 
     * @param {CvSearchStepNameDto} [step] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchResults(cvSearchId: number, step?: CvSearchStepNameDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).getCvSearchResults(cvSearchId, step, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get CV Search tag dictionary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchTags(options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).getCvSearchTags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Status and candidate count of the default CV Search, read live from CV Search. candidatesCount is the number of candidates matching the tag expression after the latest finished structural filter step, absent until that step finishes. defaultCvSearch is absent when the process has no default CV Search. When CV Search is unreachable the request fails with an error status. Readable by any authenticated user, like the process details; changing the default stays limited to the process owner.
     * @summary Get the default CV Search of a recruitment process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).getProcessDefaultCvSearch(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tags (without the languages category) and must-have / nice-to-have keywords come from the job description analysis of the default CV Search; they stay empty while it is RUNNING, after an ERROR, without a default CV Search or when CV Search is unreachable. Languages and location are mapped from the process deterministically and are always returned: languages unknown to CV Search are listed in unrecognizedLanguages, a location outside the location taxonomy has status UNRECOGNIZED. The response is built on every call (dictionary lookups per language), so poll the default CV Search status instead and reload the proposal once it is PAUSED.
     * @summary Suggested criteria of the default CV Search for the process configuration wizard
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessDefaultCvSearchProposal(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).getProcessDefaultCvSearchProposal(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user\'s CV Search processes
     * @param {number} pageSize 
     * @param {number} page 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {CvSearchProcessSearchSortByDto} [sortBy] 
     * @param {string} [name] 
     * @param {Array<CvSearchProcessStatusDto>} [statuses] 
     * @param {string} [createdBy] 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {string} [processId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCvSearchProcesses(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: CvSearchProcessSearchSortByDto, name?: string, statuses?: Array<CvSearchProcessStatusDto>, createdBy?: string, dateFrom?: string, dateTo?: string, processId?: string, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).listCvSearchProcesses(pageSize, page, sortOrder, sortBy, name, statuses, createdBy, dateFrom, dateTo, processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces one or more source tags with a target tag in the same category. CV assignments and aliases are rewritten onto the target, then source tags are deleted. 
     * @summary Merge CV Search tag values
     * @param {MergeCvSearchTagsRequestDto} mergeCvSearchTagsRequestDto Source tags to replace with a target tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mergeCvSearchTags(mergeCvSearchTagsRequestDto: MergeCvSearchTagsRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).mergeCvSearchTags(mergeCvSearchTagsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Synchronous preview for the tag editor. Ranking: number of matched optional tags (tags under an OR and not under NOT); required (AND-only) and excluded tags are not counted. With cvSearchId of a search started from a recruitment process, that process\' candidates are excluded. 
     * @summary Live preview of candidates matching the tag expression (no process, no AI)
     * @param {PreviewCvSearchRequestDto} previewCvSearchRequestDto CV Search live preview criteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewCvSearch(previewCvSearchRequestDto: PreviewCvSearchRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).previewCvSearch(previewCvSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retry after a failed creation or analysis. Starts a new CV Search from the process (job description analysis only) and makes it the default; the previous default stays on the list without the flag. Failures of CV Search are returned as errors. defaultCvSearch is absent when the process has no job description.
     * @summary Create a new default CV Search for a recruitment process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recreateProcessDefaultCvSearch(processId: string, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).recreateProcessDefaultCvSearch(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Changes only the name shown in the application; the search criteria and results stay untouched.
     * @summary Rename a CV Search in any status
     * @param {number} cvSearchId 
     * @param {RenameCvSearchRequestDto} renameCvSearchRequestDto New CV Search name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public renameCvSearch(cvSearchId: number, renameCvSearchRequestDto: RenameCvSearchRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).renameCvSearch(cvSearchId, renameCvSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rewind CV Search process to inferred tags review
     * @param {number} cvSearchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rewindCvSearchProcessToInferredTags(cvSearchId: number, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).rewindCvSearchProcessToInferredTags(cvSearchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search CV Search tags with pagination
     * @param {number} pageSize 
     * @param {number} page 
     * @param {string} [searchPhrase] 
     * @param {string} [category] Restrict results to one tag category code.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCvSearchTags(pageSize: number, page: number, searchPhrase?: string, category?: string, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).searchCvSearchTags(pageSize, page, searchPhrase, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Puts the tag into the group of `parentId` or removes it from its group (`parentId: null`). A tag expression leaf pointing at the parent also matches its children; children stay separate tags. The parent must be in the same category and not be a child itself, the tag must not be a group parent (otherwise 400). 
     * @summary Set or clear the group parent of a CV Search tag value
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {SetCvSearchTagParentRequestDto} setCvSearchTagParentRequestDto Group parent of a CV Search tag value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setCvSearchTagParent(tagValueId: number, setCvSearchTagParentRequestDto: SetCvSearchTagParentRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).setCvSearchTagParent(tagValueId, setCvSearchTagParentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the current default CV Search of the linked recruitment process. Fails with 400 when the CV Search is not linked to a recruitment process.
     * @summary Set a CV Search as the default of its recruitment process
     * @param {number} cvSearchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setDefaultCvSearch(cvSearchId: number, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).setDefaultCvSearch(cvSearchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start CV Search from manual criteria
     * @param {StartCvSearchRequestDto} startCvSearchRequestDto CV Search manual start criteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startCvSearch(startCvSearchRequestDto: StartCvSearchRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).startCvSearch(startCvSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start CV Search from a recruitment process
     * @param {string} processId 
     * @param {StartCvSearchFromProcessRequestDto} startCvSearchFromProcessRequestDto CV Search process details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startCvSearchFromProcess(processId: string, startCvSearchFromProcessRequestDto: StartCvSearchFromProcessRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).startCvSearchFromProcess(processId, startCvSearchFromProcessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a CV Search contact list status
     * @param {number} cvSearchId 
     * @param {string} candidateId 
     * @param {UpdateCvSearchContactListStatusRequestDto} updateCvSearchContactListStatusRequestDto CV Search contact list status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCvSearchContactListStatus(cvSearchId: number, candidateId: string, updateCvSearchContactListStatusRequestDto: UpdateCvSearchContactListStatusRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).updateCvSearchContactListStatus(cvSearchId, candidateId, updateCvSearchContactListStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Full replacement: tagExpression, location and keywords are always overwritten - send the whole editor state. Omitted or blank name keeps the current name. Omitted jobDescription keeps it, empty string clears it. 
     * @summary Save all criteria of a paused CV Search (tags, location, keywords, JD, name)
     * @param {number} cvSearchId 
     * @param {UpdateCvSearchCriteriaRequestDto} updateCvSearchCriteriaRequestDto CV Search criteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCvSearchCriteria(cvSearchId: number, updateCvSearchCriteriaRequestDto: UpdateCvSearchCriteriaRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).updateCvSearchCriteria(cvSearchId, updateCvSearchCriteriaRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update CV Search JD keywords before continuing the process
     * @param {number} cvSearchId 
     * @param {UpdateCvSearchJdKeywordsRequestDto} updateCvSearchJdKeywordsRequestDto CV Search JD keywords update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCvSearchJdKeywords(cvSearchId: number, updateCvSearchJdKeywordsRequestDto: UpdateCvSearchJdKeywordsRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).updateCvSearchJdKeywords(cvSearchId, updateCvSearchJdKeywordsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update CV Search location criteria before continuing the process
     * @param {number} cvSearchId 
     * @param {UpdateCvSearchLocationCriteriaRequestDto} updateCvSearchLocationCriteriaRequestDto CV Search location criteria update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCvSearchLocationCriteria(cvSearchId: number, updateCvSearchLocationCriteriaRequestDto: UpdateCvSearchLocationCriteriaRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).updateCvSearchLocationCriteria(cvSearchId, updateCvSearchLocationCriteriaRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Changes the canonical name of an existing tag. The identifier stays the same. A name conflict in the same category returns 409. 
     * @summary Rename a CV Search tag value
     * @param {number} tagValueId CV Search tag value identifier.
     * @param {UpdateCvSearchTagRequestDto} updateCvSearchTagRequestDto Renamed CV Search tag value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCvSearchTag(tagValueId: number, updateCvSearchTagRequestDto: UpdateCvSearchTagRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).updateCvSearchTag(tagValueId, updateCvSearchTagRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save the CV Search tag expression before continuing the process
     * @param {number} cvSearchId 
     * @param {UpdateCvSearchTagExpressionRequestDto} updateCvSearchTagExpressionRequestDto CV Search tag expression update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCvSearchTagExpression(cvSearchId: number, updateCvSearchTagExpressionRequestDto: UpdateCvSearchTagExpressionRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvSearchRestApiFp(this.configuration).updateCvSearchTagExpression(cvSearchId, updateCvSearchTagExpressionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetCvSearchMatchesRadiusKmEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100,
} as const;
export type GetCvSearchMatchesRadiusKmEnum = typeof GetCvSearchMatchesRadiusKmEnum[keyof typeof GetCvSearchMatchesRadiusKmEnum];
